import React from 'react'

/**
 * Graph image section
 * @param {string|null} image - Base64 encoded image or null
 */
export const Graph = ({ image }) => {
    if (!image) {
        return <></>
    }

    return (
        <>
            <h2>Graphique / Graph :</h2>
            <img alt='' src={image} />
        </>
    )
}
